module.exports = __webpack_public_path__ + "img/u888.8d3978e2.svg";